import React from "react";
import styled from 'styled-components';

import { Contributor } from "./Contributor";
import contributorsData from "../data/contributors.json";

const ContributorCategory = styled.div`
	margin-bottom: 1.5rem;
`;

const ContributorCategoryTitle = styled.h4`
	${(props) => props.theme.typography.heading2XS}
	color: ${(props) => props.theme.colors.yellow4};
	text-transform: uppercase;
	margin-bottom: 0.75rem;
	display: flex;
	align-items: center;
	gap: 0.4rem;
`;

const ContributorRowContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	row-gap: 1rem;
	column-gap: 1.5rem;
`;

export class ContributorRow extends React.Component {

	render() {
		const { roleLabel, contributorIds } = this.props;

		return (
			<ContributorCategory>
				{roleLabel && <ContributorCategoryTitle>{roleLabel}</ContributorCategoryTitle>}
				<ContributorRowContainer>
					{contributorIds.map(contributorId => {
						const contributor = contributorsData.find(c => c.id === contributorId);
						
						if (!contributor) return null;
						
						return (
							<Contributor 
								key={contributorId}
								id={contributorId}
								name={contributor.name}
								nationality={contributor.nationality}
								avatarUrl={contributor.avatarUrl}
							/>
						);
					})}
				</ContributorRowContainer>
			</ContributorCategory>
		);
	}
}
